isMatchingMethodType